// components/landing/PartnersCarousel.js
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

// Importe todas as imagens
import lojaintegrada from '../../assets/parceiros/lojaintegrada.png';
import novemshop from '../../assets/parceiros/novemshop.png';
import prestashop from '../../assets/parceiros/prestashop.png';
import shopify from '../../assets/parceiros/shopify.png';
import woo from '../../assets/parceiros/woo.png';
import yamp from '../../assets/parceiros/yamp.png';
import vetex from '../../assets/parceiros/vetex.png';
import vnda from '../../assets/parceiros/olist.png';
import tray from '../../assets/parceiros/tray.png';
import eversa from '../../assets/parceiros/eversa.png';

const PartnersCarousel = () => {
  const partners = [
    { name: "Lojaintegrada", logo: lojaintegrada },
    { name: "Novemshop", logo: novemshop },
    { name: "Prestashop", logo: prestashop },
    { name: "Shopify", logo: shopify },
    { name: "Vetex", logo: vetex },
    { name: "Woo", logo: woo },
    { name: "Yamp", logo: yamp },
    { name: "Vnda", logo: vnda },
    { name: "Tray", logo: tray },
    { name: "Eversa", logo: eversa },
  ];

  // Duplica os parceiros para criar um efeito de loop contínuo mais suave
  const duplicatedPartners = [...partners, ...partners, ...partners];

  return (
    <section className="py-24 bg-white border-t border-gray-100">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight mb-4">
            Criados sob medida para cada negócio
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-lg font-light leading-relaxed">
            Veja algumas das marcas e plataformas integradas à CriaApp.
          </p>
        </div>

        <div className="relative overflow-hidden">
          {/* Sombra na borda esquerda */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
          
          {/* Sombra na borda direita */}
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>

          <Swiper
            modules={[Autoplay]}
            spaceBetween={30}
            slidesPerView={2}
            breakpoints={{
              640: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 4,
              },
              1024: {
                slidesPerView: 5,
              },
            }}
            autoplay={{
              delay: 1,
              disableOnInteraction: false,
            }}
            speed={5000}
            loop={true}
            loopAdditionalSlides={partners.length}
            className="partners-swiper"
            grabCursor={false}
            resistance={false}
            resistanceRatio={0}
          >
            {duplicatedPartners.map((partner, index) => (
              <SwiperSlide key={index}>
                <div className="flex justify-center items-center h-32 p-4 mix-blend-multiply">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="w-40 h-40 object-contain grayscale opacity-40 contrast-125 hover:grayscale-0 hover:opacity-100 transition-all duration-500 ease-out drop-shadow-sm hover:drop-shadow-lg"
                    loading="lazy"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default PartnersCarousel;